export default __webpack_public_path__ + "static/media/copy.e88a7cef.svg";